import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";

const logos = [
  // require("../assets/images/LogoSwiper/qatar.png"),
  require("../assets/images/LogoSwiper/worldBankGroup.png"),
  require("../assets/images/LogoSwiper/theglobalfund.png"),
  require("../assets/images/LogoSwiper/novonordisk.png"),
  require("../assets/images/LogoSwiper/bill-melinda-gates-foundation-logo.webp"),
  require("../assets/images/LogoSwiper/gavi.png"),
  // require("../assets/images/LogoSwiper/whologo.png"),
  require("../assets/images/LogoSwiper/isa.png"),
  require("../assets/images/LogoSwiper/stoptb.png"),
  require("../assets/images/LogoSwiper/nigeriamoh.png"),
  require("../assets/images/LogoSwiper/sante.png"),
  require("../assets/images/LogoSwiper/kwe.png"),
];

const LogoSwiper = () => {
  return (
    <div
      style={{
        width: "100%",
        margin: "0 auto",
        marginTop: "100px",
        paddingTop: "25px",
      }}
      className="swiperLogos"
    >
      <Swiper
        modules={[Autoplay]}
        slidesPerView={7}
        spaceBetween={5}
        loop={true}
        // autoplay={true}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
      >
        {logos.map((logo, index) => (
          <SwiperSlide key={index}>
            <img
              src={logo}
              alt={`Logo ${index + 1}`}
              style={{
                width: "90%",
                height: "auto",
                aspectRatio: "3/2",
                objectFit: "contain",
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default LogoSwiper;
